import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react'
import { IoMenuSharp } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar';
import { Account } from 'appwrite';
import appwriteClient from '../appwrite.config';
import ActivityWall from '../components/ActivityWall';

function Home() {
    const navigate = useNavigate();
    const account = new Account(appwriteClient);

   
         account.listSessions().then((response)=>{
       console.log(response)
        }).catch((error)=>{
     console.log(error)
     navigate('/login', { replace: true })
        })
       
   
      
   
     



    
  
    const[menuVisible,setMenuVisible]=useState(false);






    return (
<>

<div className='flex flex-row h-screen' h>
    
   {
    <div className={` bg-slate-100  w-80 ${menuVisible?'max-sm:flex-col':'max-sm:hidden'} max-sm:sticky p-5 h-screen max-sm:flex-row  flex-row  max-sm:p-1`}>
    <div className='max-sm:flex max-sm:p-1 max-sm:w-full'>
    <div className='hidden  max-sm:flex max-sm:my-auto max-sm:justify-center max-sm:mx-6'>{
        <button onClick={()=>{setMenuVisible(!menuVisible)}}>
        <IoMenuSharp  size={20} />
        </button>
        }</div>
        <div className=' text-2xl w-fit font-bold font-serif text-center mx-auto mb-6 max-sm:mb-0 max-sm:text-xl  hover:cursor-pointer'>
 
Maa Tyre Retreads
</div>
</div>

<div style={{height:"90%"}} className='flex-col  py-5 mb-15 w-full  text-center overflow-y-scroll'>
    <h1 className='mb-3'>Tyre Pickup & Delivery</h1>
<div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 '  to='/workorder'>Work Order</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white  ml-8 mr-8'>
    <Link className=' py-3 ' to='/pickuprequest'>Pickup Request</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/invoice'>Invoice</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/trippanel'>Trip Panel</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className=' py-3 ' to='/namelist'>Name List</Link>
    </div>
    <h1 className='mb-3'>Tyre Tracking</h1>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/tyreLifecycle'>Tyre Lifecycle</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/tyrefitment'>Fitment Details</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/tyretracking'>Tracking Details</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/tyreremoval'>Removal Details</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className=' py-3 ' to='/pickuprequest'> Projection</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className=' py-3 ' to='/vehicleprofile'>Vehicle Profile</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className=' py-3 ' to='/monthlyRun'>Monthly Running</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className=' py-3 ' to='/pickuprequest'>Tyre Profile</Link>
    </div>
    <h1 className='mb-3'>User Panel</h1>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/zoneregister'>Zone Register</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/useractivity'>User Activity</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/userRegister'>User Register</Link>
    </div>
    <div className='mb-4 bg-slate-300 py-3 rounded-md justify-center hover:bg-blue-500 hover:text-white ml-8 mr-8'>
    <Link className='  py-3 ' to='/tyretracking'>Location Tracking</Link>
    </div>
</div>

    </div>
    }
    {
    <div className={`w-4/5 max-sm:w-full  h-screen  flex-col ${menuVisible?'max-sm:hidden':'max-sm:flex'}`}>
<div className='w-full     flex-wrap  rounded-sm'>
    <div className='flex-row hidden max-sm:flex'>
       
    <button className='absolute left-2 top-3' onClick={()=>{setMenuVisible(!menuVisible)}}>
        <IoMenuSharp  size={25} />
        </button>
        
       
    </div>
    

</div>
<div className='w-full  flex-col '>
        <ActivityWall/>
</div>
    </div>
    }
</div>
</>
  )
}

export default Home